import { render, staticRenderFns } from "./mfa-auth.vue?vue&type=template&id=1871e750&scoped=true&"
import script from "./mfa-auth.vue?vue&type=script&lang=js&"
export * from "./mfa-auth.vue?vue&type=script&lang=js&"
import style0 from "./mfa-auth.vue?vue&type=style&index=0&id=1871e750&lang=scss&scoped=true&"
import style1 from "@/assets/auth-screen.scss?vue&type=style&index=1&id=1871e750&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1871e750",
  null
  
)

component.options.__file = "mfa-auth.vue"
export default component.exports